import React from "react";

import WPHeading from "../../../packages/WPHeading";

import { convertUptoDigits } from "../../../utils/appUtils";

const ChemicalDensityRenderer = ({ value }) => {
  const formattedValue = convertUptoDigits(value, 4);

  return (
    <div className="flex-ai-center">
      <WPHeading type="default" size="small" secondary tooltip={formattedValue}>
        <span>{formattedValue}</span>
      </WPHeading>
    </div>
  );
};
export default ChemicalDensityRenderer;
